import { PatientTab, ReferralTab } from "../constants/AllPatientRecord";
import API from "./api";
import {
  MyPatientSearch,
  ReAuthReferralRequest,
  GetPostPutIcd10Records,
} from "../models/Patient";
import { GetQueryString } from "../utils";
import {
  MaxAllowedSocDateQuery,
  ReAuthSubmitPayload,
  ReferralSubmitPayload,
} from "../models/Api/AllPatientRecord";
import { AllPendingUnassignStaff } from "../models/Filter";
import { DocumentPayload, ResendFaxPayload } from "../models/Document";

export const PostAllPatientRecord = (configUrl: string, payload: any) =>
  API.post(`${configUrl}api/patients/patientRecords`, payload);

export const GetPatientTab = (path?: string) => {
  if (path) {
    return ReferralTab;
  } else {
    return PatientTab;
  }
};

export const GetPatientDetailById = (
  configUrl: any,
  referralId: number,
  patientId: number
) =>
  API.get(
    `${configUrl}api/referral/ReferralOverview/${patientId}/${referralId}`
  );

export const GetIcd10Records = (configUrl: any, id: number, typeId: number) =>
  API.get(`${configUrl}api/icdcodes/${id}/${typeId}`);

export const PostIcd10RecordsData = (
  configUrl: any,
  payload: GetPostPutIcd10Records
) => API.postApi(`${configUrl}api/icdcodes`, payload);

export const PutICD10 = (configUrl: string, payload: any) =>
  API.putApi(`${configUrl}api/icdcodes/${payload.id}`, payload);

export const GetPatientRequestById = (
  configUrl: any,
  referralId: string,
  patientId: string
) => API.get(`${configUrl}api/requestintake/${referralId}/${patientId}`);

export const PutPatientRequestById = (configUrl: any, payload: any) =>
  API.putApi(
    `${configUrl}api/requestintake/${payload.referralDetail.referralId}`,
    payload
  );

export const PostPatientRequest = (configUrl: any, payload: any) =>
  API.postApi(`${configUrl}api/requestintake`, payload);

export const PostReferralSubmit = (
  configUrl: string,
  payload: ReferralSubmitPayload
) =>
  API.postApi(`${configUrl}api/referral/Submit?${GetQueryString(payload)}`, {});

export const GetDocuments = (configUrl: string, id: string, type: number) =>
  API.get(`${configUrl}api/documents/${id}/${type}`);

export const PutDocumentsDetail = (configUrl: string, payload: any) =>
  API.putApi(`${configUrl}api/documents?id=${payload.id}`, payload);

export const PostDocumentsDetail = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}api/documents`, payload);

export const GetReferralDocuments = (
  configUrl: string,
  payload: DocumentPayload
) => {
  return API.postApi(`${configUrl}api/documents/searchDocument`, payload);
};

export const PutDocumentsFile = (
  configUrl: string,
  payload: any,
  referralId: string
) =>
  API.putApi(
    `${configUrl}api/documents/Document?referralId=${referralId}`,
    payload
  );

export const SaveDocumentsFile = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}api/documents/Document`, payload);

export const GetReauthReferralRequestById = (
  configUrl: any,
  reAuthId: number
) => API.get(`${configUrl}api/requestdetail/${reAuthId}`);

export const PostReauthReferralRequest = (
  configUrl: string,
  payload: ReAuthReferralRequest
) => API.postApi(`${configUrl}api/requestdetail`, payload);

export const PutReauthReferralRequest = (configUrl: string, payload: any) =>
  API.putApi(
    `${configUrl}api/requestdetail/${payload.referralRequest.serviceRequestId}`,
    payload
  );

export const DeleteDocumentsFile = (
  configUrl: string,
  blobId: any,
  userDeleted: string, 
  referralBlobId: number
) =>
  API.delete(
    `${configUrl}api/documents/Document?blobId=${blobId}&userDeleted=${userDeleted}&referralBlobId=${referralBlobId}`
  );

export const UpdateReauthServiceRequest = (configUrl: string, payload: any) =>
  API.putApi(
    `${configUrl}api/servicerequest/ReAuth/${payload.serviceRequestId}`,
    payload
  );

export const SaveReauthServiceRequest = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}api/servicerequest/ReAuth`, payload);

export const PostReauthReferralSubmit = (
  configUrl: string,
  reAuthId: string,
  payload: ReAuthSubmitPayload
) =>
  API.postApi(
    `${configUrl}api/referral/SubmitReAuth/${reAuthId}?${GetQueryString(
      payload
    )}`,
    {}
  );

export const GetServiceRequestRecords = (
  configUrl: any,
  reAuthId: number,
  startOfCareDate?: string
) => {
  if (startOfCareDate === undefined) {
    return API.get(`${configUrl}api/servicerequest/ReAuth/${reAuthId}`);
  } else {
    return API.get(
      `${configUrl}api/servicerequest/ReAuth/${reAuthId}?startOfCareDate=${startOfCareDate}`
    );
  }
};

export const PostCheckEligibility = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}Eligibility/Check`, payload);

export const PostMyPatientList = (
  configUrl: string,
  payload: MyPatientSearch
) => API.postApi(`${configUrl}api/patients/searchPatientRecords`, payload);

export const PostIncompletePatientList = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}api/patients/getIncompleteRequests`, payload);

export const PutMyPatientList = (
  configUrl: string,
  assignedToStaffId: number,
  payload: any
) => {
  return API.putApi(
    `${configUrl}api/patients/assignStaff?assignedToStaffId=${assignedToStaffId}`,
    payload
  );
};

export const PutIncompletePatientList = (
  configUrl: string,
  assignedUserId: number,
  payload: any
) => {
  return API.putApi(
    `${configUrl}api/patients/assignStaffToIncompleteRequest?assignedUserId=${assignedUserId}`,
    payload
  );
};

export const GetDocumentDownload = (
  configUrl: string,
  blobId: number,
  type?: string
) => API.get(`${configUrl}api/Blob/GetBlobById/${blobId}`, type);

export const GetExcelDownload = (
  configUrl: string,
  path: string,
  type: string
) => API.get(`${configUrl}api/users/${path}`, type);

export const PostGenerateAuthTemplate = (
  configUrl: string,
  referralId: string
) => API.postApi(`${configUrl}api/documents/GetAuthDocument/${referralId}`, {});

export const PostAllPendingUnassignStaff = (
  configUrl: string,
  payload: AllPendingUnassignStaff
) => API.postApi(`${configUrl}api/patients/UnassignStaff`, payload);

export const PostAttachLetter = (configUrl: string, payload: FormData) =>
  API.postApi(`${configUrl}api/documents/AttachLetter`, payload);

export const PostResendFax = (
  configUrl: string,
  payload: ResendFaxPayload,
) => API.postApi(`${configUrl}api/fax/FaxDetail`, payload);

export const PostResendEmail = (
  configUrl: string,
  notificationEmailParameterId: number | null,
) => API.postApi(`${configUrl}api/documents/ReSendNotificationEmail?notificationEmailParameterId=${notificationEmailParameterId}`, {});

export const GetServiceRequestIsRetro = (
  configUrl: string,
  socDate: string,
  payload: any,
) => API.get(`${configUrl}api/servicerequest/IsRetro/${socDate}?${GetQueryString(payload)}`, {});

export const GetMaxAllowedSocDate = (
  configUrl: string,
  query: MaxAllowedSocDateQuery,
) => API.get(`${configUrl}api/authorization/MaxAllowedSocDate?${GetQueryString(query)}`);
